import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import RainAnimation from './RainAnimation';

interface IconProps {
  className?: string;
}

function LightSnowIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-light-snow"
    >
      <path
        d="M55.0684 22C67.2823 22 77.1836 31.9013 77.1836 44.1152C77.1836 44.5608 77.1695 45.0033 77.1436 45.4424H84.3457C93.6283 45.4424 101.154 52.9674 101.154 62.25C101.154 71.5325 93.6282 79.0576 84.3457 79.0576H34.8076C25.5251 79.0576 18.0002 71.5325 18 62.25C18 53.5784 24.5669 46.4402 32.999 45.5381C32.9691 45.0676 32.9531 44.5932 32.9531 44.1152C32.9531 31.9012 42.8544 22 55.0684 22Z"
        fill="white"
        fillOpacity="0.7"
      >
        <FloatAnimation />
      </path>
      <path
        d="M59.0352 84C59.8636 84 60.5352 84.6716 60.5352 85.5V88.1611L62.8604 86.8193C63.5777 86.4053 64.495 86.6509 64.9092 87.3682C65.3234 88.0855 65.0777 89.0027 64.3604 89.417L62.0557 90.7471L64.3623 92.0791C65.0796 92.4934 65.3253 93.4106 64.9111 94.1279C64.4969 94.8453 63.5797 95.0909 62.8623 94.6768L60.5352 93.333V96.0195C60.5351 96.8479 59.8635 97.5195 59.0352 97.5195C58.2068 97.5195 57.5353 96.8479 57.5352 96.0195V93.3574L55.25 94.6768C54.5326 95.0909 53.6154 94.8453 53.2012 94.1279C52.787 93.4106 53.0328 92.4934 53.75 92.0791L56.0566 90.7471L53.752 89.417C53.0347 89.0027 52.789 88.0855 53.2031 87.3682C53.6173 86.6508 54.5346 86.4053 55.252 86.8193L57.5352 88.1367V85.5C57.5352 84.6716 58.2068 84 59.0352 84Z"
        fill="white"
      >
        <RainAnimation duration={1.8} delay={0} moveY={6} />
      </path>
      <path
        d="M72.1475 72C72.9759 72 73.6474 72.6716 73.6475 73.5V76.1611L75.9727 74.8193C76.69 74.4053 77.6073 74.6508 78.0215 75.3682C78.4357 76.0855 78.1899 77.0027 77.4727 77.417L75.168 78.7471L77.4746 80.0791C78.1918 80.4934 78.4376 81.4106 78.0234 82.1279C77.6092 82.8453 76.692 83.0909 75.9746 82.6768L73.6475 81.333V84.0195C73.6474 84.8479 72.9758 85.5195 72.1475 85.5195C71.3191 85.5195 70.6476 84.8479 70.6475 84.0195V81.3574L68.3623 82.6768C67.6449 83.0909 66.7277 82.8453 66.3135 82.1279C65.8993 81.4106 66.145 80.4934 66.8623 80.0791L69.1689 78.7471L66.8643 77.417C66.147 77.0027 65.9013 76.0855 66.3154 75.3682C66.7296 74.6509 67.6469 74.4053 68.3643 74.8193L70.6475 76.1367V73.5C70.6475 72.6716 71.319 72 72.1475 72Z"
        fill="white"
      >
        <RainAnimation duration={1.8} delay={0.5} moveY={6} />
      </path>
      <path
        d="M48.0352 72C48.8636 72 49.5352 72.6716 49.5352 73.5V76.1611L51.8604 74.8193C52.5777 74.4053 53.495 74.6509 53.9092 75.3682C54.3234 76.0855 54.0777 77.0027 53.3604 77.417L51.0557 78.7471L53.3623 80.0791C54.0796 80.4934 54.3253 81.4106 53.9111 82.1279C53.4969 82.8453 52.5797 83.0909 51.8623 82.6768L49.5352 81.333V84.0195C49.5351 84.8479 48.8635 85.5195 48.0352 85.5195C47.2068 85.5195 46.5353 84.8479 46.5352 84.0195V81.3574L44.25 82.6768C43.5326 83.0909 42.6154 82.8453 42.2012 82.1279C41.787 81.4106 42.0328 80.4934 42.75 80.0791L45.0566 78.7471L42.752 77.417C42.0347 77.0027 41.789 76.0855 42.2031 75.3682C42.6173 74.6508 43.5346 74.4053 44.252 74.8193L46.5352 76.1367V73.5C46.5352 72.6716 47.2068 72 48.0352 72Z"
        fill="white"
      >
        <RainAnimation duration={1.8} delay={1.0} moveY={6} />
      </path>
    </svg>
  );
}

export default memo(LightSnowIcon);
